import React from 'react';
import Simple from '../../../components/Layout/Simple';
import ResetPasswordContent from '../../../components/Pages/Auth/ResetPassword';

export default function ResetPassword(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: New Password`;

  return (
    <Simple>
      <ResetPasswordContent />
    </Simple>
  );
}
